import { AxiosResponse } from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

//services
import { post } from '../../services/http'
import tokenStorageService from '../../services/TokenStorageService';
import routeListen from '../../services/routeListen';

//interfaces
import { SliceStatus } from '../../interfaces/Redux';
import { AuthDetails } from '../../interfaces/Auth';

//translations
import localisation from "../../services/localisation";
import IL from "../../interfaces/localisation";



let error:any = undefined;

class LoginError extends Error {
    public payload: any

    constructor(message: string, payload: any) {
        super(message)
        this.name = 'LoginError'
        this.payload = payload
    }
}

export interface AuthState {
  authDetails: AuthDetails
  token: string,
  isLoggedIn: boolean,
  status: SliceStatus,
  error: AxiosResponse | undefined 
}

const initialState: AuthState = {
    authDetails: {
        isAuth: false,
        userName: "",
        userId: "",
        isExternal: false,
    },
    token:'',
    isLoggedIn: false,
    status: SliceStatus.initial,
    error: undefined,
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearAuth: () => initialState,
    clearErrors: (state) => ({
        ...state,
        errors: undefined
    }),
    setToken: (state, action) => {
        state.token = action.payload
        state.isLoggedIn = true
    },
    setLoginError: (state, action) => {
      state.status = SliceStatus.failed;
      state.authDetails = initialState.authDetails;
      state.error = action.payload;
    },
    loginWithExistingToken: (state, action) => {
      state.status = SliceStatus.succeeded
      state.authDetails = action.payload?.authDetails as AuthDetails
      state.isLoggedIn = true
      state.token = action.payload?.token as string
    }
  },
  extraReducers(builder) {
    builder
      .addCase(login.pending, (state) => {
        state.status = SliceStatus.loading;
        state.error = undefined;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.status = SliceStatus.succeeded
        state.authDetails = action.payload?.authDetails as AuthDetails
        state.isLoggedIn = true
        state.token = action.payload?.token as string
      })
      .addCase(login.rejected, (state) => {
        state.status = SliceStatus.failed;
        state.authDetails = initialState.authDetails;
        state.error = error;
      })
  }
})

export const login = createAsyncThunk('auth/login', async ({userName, password}: {userName: string, password: string}) => {
    const payload : any = `grant_type=password&username=${encodeURIComponent(
      userName
    )}&password=${encodeURIComponent(password)}`;

    const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Organization: routeListen.shortName(),
        Authorisation: null,
    };

    const { data } = await post("token", payload, { headers: headers }).catch(({response}) => {
        error = response;
        throw new LoginError(localisation.getLocalString(IL["Onboarding.LoginFailed"]), {status: response.status, data: response.data})
    })
    

    return loginFromAuthTokenResponse(data, userName)
    
});

export function loginFromAuthTokenResponse(data:any, userName:string){
  if(data.access_token) {
    tokenStorageService.setItem("token", data.access_token);
    tokenStorageService.setItem("userId", data.userId);
    tokenStorageService.setItem('orgShortName', data.orgShortName);
    tokenStorageService.setItem('userName', userName);
        

    return {
        authDetails: {
            isAuth: false,
            userName: userName,
            userId: data.userId,
            isExternal: false,
        },
        token: data.access_token,
        status: SliceStatus.succeeded,
        error: '',
    }
  }   
}

export const { clearAuth, clearErrors, setToken, setLoginError, loginWithExistingToken } = authSlice.actions 

export default authSlice.reducer



